var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26953 14.9805L1.01953 6.73047C0.589844 6.34375 0.589844 5.69922 1.01953 5.26953C1.40625 4.88281 2.05078 4.88281 2.48047 5.26953L10 12.832L17.5195 5.3125C17.9062 4.88281 18.5508 4.88281 18.9805 5.3125C19.3672 5.69922 19.3672 6.34375 18.9805 6.73047L10.6875 14.9805C10.3008 15.4102 9.65625 15.4102 9.26953 14.9805Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowDark);
export default __webpack_public_path__ + "static/media/down_arrow_dark.a05eae86bdda44e105a340e6799b7606.svg";
export { ForwardRef as ReactComponent };